import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { setFeedInfoFeed, setInputFieldTargetUrl, setSelectedFieldIdx, setSelectedFieldName, setSelectedFieldPath } from '../../../../slices/feeds/reducer';
import CustomCollapse from "../../../../Components/Common/CustomCollapse";
import { Label, Input, Button } from "reactstrap";
import { setFeedModalType, toggleAddFieldModal, toggleSelectPathModal } from '../../../../slices/modals/reducer';
import { loadSource } from '../../../../slices/feeds/thunk';
import checkPermission from '../../../../Components/Hooks/PermissionHook';

function FieldCollapse({ idx, name, path, targetUrl, onRemove, onDuplicate }) {
  const dispatch = useDispatch();
  const [isCollapsed, setIsCollapsed] = useState(true);
  
  const selectStates = createSelector(state => state, state => ({
    feedInfo: state.Feed.feedInfo,
    brandPath: state.MenuData.brandPath
  }));
  const {feedInfo, brandPath} = useSelector(selectStates);
  
  function onRemove() {
    const filteredFeed = feedInfo.feed.filter((item, index) => index !== idx);
    dispatch(setFeedInfoFeed(filteredFeed));
  }

  function onDuplicate() {
    const foundFeed = feedInfo.feed.find((item, index) => index === idx && item.name === name && item.path === path);
    dispatch(setFeedInfoFeed([...feedInfo.feed, foundFeed]))
  }

  async function pickGroup() {
    dispatch(setSelectedFieldIdx(idx));
    dispatch(setFeedModalType("targetfield"));
    // await dispatch(loadSource(feedInfo.source));
    dispatch(toggleAddFieldModal());
    // dispatch(toggleSelectPathModal());
  };

  function handlePath(e) {
    dispatch(setSelectedFieldPath({path: e.target.value, idx: idx}));
  }

  function handleTargetUrl(e) {
    dispatch(setInputFieldTargetUrl({targetUrl: e.target.value, idx: idx}));
  }

  function handleNameChange(e) {    
    dispatch(setSelectedFieldName({name: e.target.textContent, idx: idx}));
    setTimeout(() => {
      const range = document.createRange();
      const selection = window.getSelection();
      
      // Set the cursor to the end of the text content
      range.selectNodeContents(e.target);
      range.collapse(false); // Move the cursor to the end
      selection.removeAllRanges();
      selection.addRange(range);
    }, 1);
  
  }

  const canEdit = checkPermission("brands", brandPath, "feedEdit");

  return (
    <CustomCollapse
      key={idx}
      icon={<i className='ri-code-line fs-16 me-3'></i>}
      className={"field-accordion"}
      name={name}
      toggler={"field-" + idx}
      btn={"btn-soft-info"}
      onRemove={onRemove}
      onDuplicate={onDuplicate}
      canEdit={canEdit}
      isCollapsed={isCollapsed}
      onChange={handleNameChange}
      setIsCollapsed={setIsCollapsed}
    >
      <div className='d-flex flex-md-row flex-column align-items-end justify-content-start gap-2'>
        <div className='w-100'>
          <Label htmlFor='path'>Path</Label>
          <Input
            type='text'
            name='path'
            id='path'
            onChange={handlePath}
            value={path}
            disabled={!canEdit}
          />
        </div>
        <div className='w-100'>
          <Label htmlFor='targetUrl'>Target URL</Label>
          <Input
            type='text'
            placeholder='Ex. Dynamic Odds - Football - Premier League'
            name='targetUrl'
            id='targetUrl'
            onChange={handleTargetUrl}
            value={targetUrl}
            disabled={!canEdit}
          />
        </div>
        <Button color='info' style={{ whiteSpace: "nowrap" }} onClick={pickGroup} disabled={!canEdit}>
          Select Field <i className='mdi mdi-link fs-13'></i>
        </Button>
      </div>
    </CustomCollapse>
  )
}

export default FieldCollapse;